/*
 *  Use to show/hide element based on an agent feature & language
 *
 *  Usage: <div agent-feature="agent-feature-name" agent-feature-language="server.language"></div>
 *
 *         agentFeatureHide - set to true if element should be hidden if agent feature is enabled for language
 */
;(function () {
  'use strict'

  angular
    .module('contrast.features')
    .directive('agentFeature', [
      '$log',
      'FeaturesService',
      'AGENT_FEATURE',
      agentFeature
    ])

  function agentFeature($log, FeaturesService, AGENT_FEATURE) {
    return {
      link: link
    }

    function link(scope, element, attrs) {
      var agentFeatureHide = !angular.isUndefined(attrs.agentFeatureHide),
        agentFeatureLanguage = scope.$eval(attrs.agentFeatureLanguage),
        agentFeatureNames = attrs.agentFeature.split(','),
        i = 0,
        agentFeatureKeycodes = [],
        error = true

      for (; i < agentFeatureNames.length; i++) {
        if (
          angular.isDefined(agentFeatureNames[i]) &&
          angular.isDefined(AGENT_FEATURE[agentFeatureNames[i]])
        ) {
          agentFeatureKeycodes.push(AGENT_FEATURE[agentFeatureNames[i]])
          error = false
        }
      }

      if (error) {
        $log.error(
          '[agentFeature]: agentFeatureName (' +
            agentFeatureNames +
            ') is undefined or does not exist in AGENT_FEATURE'
        )
        return
      }

      if (agentFeatureLanguage) {
        showOrHideIfEnabled(
          agentFeatureKeycodes,
          agentFeatureLanguage,
          agentFeatureHide,
          element
        )
      }

      scope.$watch(attrs.agentFeatureLanguage, function (newVal, oldVal) {
        if (!angular.isUndefined(newVal) && newVal !== oldVal) {
          showOrHideIfEnabled(
            agentFeatureKeycodes,
            newVal,
            agentFeatureHide,
            element
          )
        }
      })
    }

    function showOrHideIfEnabled(keycodes, language, hide, el) {
      FeaturesService.isAgentFeatureEnabled(keycodes, language).then(function (
        enabled
      ) {
        if (enabled !== hide) {
          el.show()
        } else {
          el.hide()
        }
      })
    }
  }
})()
